import { createFileRoute, Navigate } from "@tanstack/react-router";
import React from "react";

/**
 * The properties for {@link ExitNodeRedirect}
 */
export type ExitNodeRedirectProps = {};

/**
 * Redirect page for exit nodes
 */
export default function ExitNodeRedirect(props: ExitNodeRedirectProps) {
    return <Navigate to={"/c/exitnodes/approved"} search={{ page: 1 }} />;
}

export const Route = createFileRoute("/_customer/c/exitnodes/")({
    component: ExitNodeRedirect,
});
